export default __webpack_public_path__ + "static/media/pizza.92c7d75d.png";